import {
  createPersistedState
} from "./chunk-256H5QT7.mjs";

// src/index.ts
var src_default = createPersistedState();
export {
  createPersistedState,
  src_default as default
};
